<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <el-form-item
        label="名称"
        prop="name"
        :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.name"></el-input>
      </el-form-item>
      <ul
        class="items-center gap-x-3 grid"
        style="grid-template-columns: 0.6fr 0.7fr 1fr auto auto auto auto"
      >
        <el-form-item
          label="类型"
          prop="type"
          :rules="[{ required: true, message: '请选择类型', trigger: 'blur' }]"
          style="min-width: 0"
        >
          <el-select v-model="state.model.type">
            <el-option
              v-for="item in $base.Meeting_Schedule_Type"
              :key="item"
              :label="item.Text"
              :value="item.Key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="日期"
          prop="date"
          :rules="[{ required: true, message: '请选择日期', trigger: 'blur' }]"
          style="min-width: 0"
        >
          <el-date-picker
            v-model="state.model.date"
            type="date"
            placeholder="--请选择--"
            value-format="YYYY-MM-DD"
          />
        </el-form-item>
        <el-form-item
          label="时间"
          prop="times"
          :rules="[{ required: true, message: '请选择时间', trigger: 'blur' }]"
          style="min-width: 0"
        >
          <el-time-picker
            v-model="state.model.times"
            is-range
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="HH:mm:ss"
            format="HH:mm"
            :default-value="[
              new Date().setHours(8, 0, 0),
              new Date().setHours(18, 0, 0),
            ]"
            :save-on-blur="false"
          />
        </el-form-item>
        <el-form-item label="是否全员日程">
          <el-radio-group v-model="state.model.is_all_personnel">
            <el-radio-button label="是" :value="1" />
            <el-radio-button label="否" :value="0" />
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否需要签到">
          <el-radio-group v-model="state.model.is_need_signin">
            <el-radio-button label="是" :value="1" />
            <el-radio-button label="否" :value="0" />
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否需要核验">
          <el-radio-group v-model="state.model.is_need_verify">
            <el-radio-button label="是" :value="1" />
            <el-radio-button label="否" :value="0" />
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否网站显示">
          <el-radio-group v-model="state.model.is_site_show">
            <el-radio-button label="是" :value="1" />
            <el-radio-button label="否" :value="0" />
          </el-radio-group>
        </el-form-item>
      </ul>
      <el-form-item
        label="所属会场"
        prop="meeting_place_id"
        :rules="[{ required: true, message: '请选择会场', trigger: 'blur' }]"
      >
        <el-select v-model="state.model.meeting_place_id" filterable>
          <template #label="{ value }">
            <div v-if="hc_map.get(value)" class="flex gap-x-5 !w-full">
              <text>{{ hc_map.get(value).name }}</text>
              <div
                class="flex flex-col items-end flex-1 text-gray-400"
                style="font-size: 12px"
              >
                {{
                  hc_map.get(value).hotel?.name +
                  "-" +
                  hc_map.get(value).hotelHall?.name
                }}
              </div>
            </div>
          </template>
          <el-option
            v-for="item in state.hc_data"
            :key="item.id"
            :label="`${item.name} ${item.hotel?.name} ${item.hotelHall?.name} ${item.hotel?.address}`"
            :value="item.id"
          >
            <div class="flex gap-x-5 !w-full">
              <text>{{ item.name }}</text>
              <div
                class="flex flex-col items-end flex-1 text-gray-400"
                style="font-size: 12px"
              >
                <text>{{ item.hotel?.name + "-" + item.hotelHall?.name }}</text>
                <text>{{ item.hotel?.address }}</text>
              </div>
            </div>
          </el-option>
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadHc"
            >
              刷新
            </el-button>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="说明">
        <el-input
          v-model="state.model.intro"
          type="textarea"
          :autosize="{ minRows: 3 }"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref } from "vue";
import {
  meeting_schedule_detail,
  meeting_schedule_add,
  meeting_schedule_edit,
} from "@/http/meeting";
import { post_response } from "@/utils/funcs";
import { data_getMeetingPlace } from "@/http/data";

export default {
  props: {
    id: Number,
    meeting_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        meeting_id: props.meeting_id,
      },
    });
    onMounted(() => {
      onLoadHc();
      onLoadDetail();
    });

    //加载会场
    const onLoadHc = () => {
      data_getMeetingPlace(props.meeting_id).then((res) => {
        if (res.status == 200) state.hc_data = res.data?.data?.list || [];
      });
    };

    //会场 id 索引，O(1) 查找
    const hc_map = computed(() => {
      const m = new Map();
      state.hc_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    //加载详情
    const onLoadDetail = () => {
      if (props.id) {
        meeting_schedule_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            state.model.times = [data.start_time, data.end_time];
          }
        });
      }
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (state.model.times?.length == 2) {
            state.model.start_time = state.model.times[0];
            state.model.end_time = state.model.times[1];
          }
          if (props.id) {
            meeting_schedule_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            meeting_schedule_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      hc_map,
      onLoadHc,
      onLoadDetail,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
